import Basics1 from 'assets/videos/Basic1/Basic1.mp4';
import Basics1Thumb from 'assets/videos/Basic1/Thumbnail.png';
import Basics2 from 'assets/videos/Basic2/Basic2.mp4';
import Basics2Thumb from 'assets/videos/Basic2/Thumbnail.png';
import KeyboardShortcuts from 'assets/videos/Keyboard/Keyboard_Shortcuts.mp4';
import KeyboardThumb from 'assets/videos/Keyboard/Thumbnail.png';
import UndoRedo from 'assets/videos/Undo/Undo_Redo_Tool.mp4';
import UndoRedoThumb from 'assets/videos/Undo/Thumbnail.png';
import {VideoInfo} from 'shared/components/VideoPlayer/entity/VideoInfo';

export const ROOM_PLANNER_VIDEOS: VideoInfo[] = [
    {
        id: 1,
        video: String(Basics1),
        thumbnail: Basics1Thumb,
        title: 'Getting started',
        shortDescription: 'Add, customise and position products.',
        description:
            'Learn how to get started with the new 3D Room Planner. This video walks you through adding, customising, and positioning products, as well as managing your project overview and materials.',
        duration: '1:50',
        watchedKey: 'room_planner_video_watched_1',
    },
    {
        id: 2,
        video: String(Basics2),
        thumbnail: Basics2Thumb,
        title: 'Basic controls',
        shortDescription: 'Reposition, rotate and align products.',
        description:
            'Discover the basic controls in the 3D Room Planner. See how to reposition, rotate, and align products, reset your design, and exit back to your dashboard.',
        duration: '0:57',
        watchedKey: 'room_planner_video_watched_2',
    },
    {
        id: 4,
        video: String(UndoRedo),
        thumbnail: UndoRedoThumb,
        title: 'Undo & redo',
        shortDescription: 'Revert and restore changes.',
        description:
            'Learn how to quickly revert changes and design with confidence with the undo & redo functionality in the 3D Room Planner.',
        duration: '1:59',
        watchedKey: 'room_planner_video_watched_4',
    },
    {
        id: 5,
        video: String(KeyboardShortcuts),
        thumbnail: KeyboardThumb,
        title: 'Keyboard shortcuts',
        shortDescription: 'Work faster with handy shortcuts.',
        description:
            'Your quick guide to keyboard mastery, making you better and faster with 3DRP.',
        duration: '1:20',
        watchedKey: 'room_planner_video_watched_5',
    },
];
